import MessageBubble from '../MessageBubble';
import { ChatPendingMessage } from './ChatPendingMessage';

export function ChatMessageList({
  loadingHistory,
  messages,
  onPreferenceVote,
  votingModelKey,
  messagesEndRef,
  pendingProgress,
}) {
  if (loadingHistory) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="space-y-4 text-center">
          <div className="mx-auto h-12 w-12 animate-spin rounded-full border-2 border-white/20 border-t-white" />
          <p className="text-sm text-muted-foreground">Chargement de l'historique...</p>
        </div>
      </div>
    );
  }

  if (messages.length === 0 && !pendingProgress) {
    return <div className="h-full" data-testid="chat-empty-state" />;
  }

  return (
    <div className="mx-auto max-w-[1800px] space-y-8" data-testid="chat-message-list">
      {messages.map((message) => (
        <MessageBubble
          key={message.id}
          message={message}
          onPreferenceVote={onPreferenceVote}
          votingModelKey={votingModelKey}
        />
      ))}
      <ChatPendingMessage pendingProgress={pendingProgress} />
      <div ref={messagesEndRef} />
    </div>
  );
}
